<template>
    <div id="demo">
        <!-- 遮罩层 -->
        <div class="container" v-show="panel">
            <div>
                <img id="image" :src="url" alt="Picture">
            </div>

            <button type="button" id="button" @click="crop">确定</button>

        </div>

        <div style="padding:20px;">
            <div class="show">
                <div class="picture" >
                    :style="'backgroundImage:url('+headerImage+')'"
                </div>
            </div>
            <div style="margin-top:20px;">
                <input type="file" id="change" accept="image" >
                @change="change"
                <label for="change"></label>
            </div>

        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            panel:true
        };
    },
    methods:{


    }
//
//    methods: {
//        denglu:function () {
//            this.$cookies.set("token",true,"16h")
////            this.$store.commit('changeLogin','100')
//            this.$router.push({ path: 'home' })
//        }
//    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/home.vue